import React from "react";
import { useNavigate } from "react-router-dom";
import smImage from "../../../src/assets/images/about-sm-screen.png";
import ssbImage from "../../../src/assets/images/about-ssb-screen.png";
import "./Home.css";
import { useSalon } from "../../context/SalonContext";
import "../../../src/style.css";

export default function Home() {
    const navigate = useNavigate();
    const { accessToken, salonUuid } = useSalon(); // ✅ get salonUuid also

    const handleBookingClick = () => {
        if (accessToken) {
            navigate("/booking");
        } else {
            navigate("/login?redirect=/booking");
        }
    };

    return (
        <div className="app-container">
            {/* Title Section */}
            <section className="app-sub-container">
                <h3 className="header-title">
                    Book Your Salon Appointments Instantly
                </h3>
                <p className="lead mb-4 custom-text">
                    Manage your salon visits and bookings with ease.
                    <br />
                    <strong>Fast. Transparent. Hassle-Free.</strong>
                </p>

                {/* ✅ Only show button if a salon is selected */}
                {salonUuid && (
                    <button
                        onClick={handleBookingClick}
                        className="btn btn-primary btn-lg shadow"
                    >
                        Book an Appointment
                    </button>
                )}
            </section>

            {/* About Apps */}
            <section className="hero-section my-3">
                <div className="row justify-content-center mx-0">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card shadow-sm h-100 text-center">
                            <img
                                src={smImage}
                                className="card-img-top mx-auto d-block app-image"
                                alt="Salon Management App"
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold">Salon Management App</h5>
                                <p className="card-text text-muted">
                                    For salon owners to manage services, staff, and appointments.
                                </p>
                                <a
                                    href="https://salonmanagement.in/"
                                    className="btn btn-outline-primary"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Learn More
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card shadow-sm h-100 text-center">
                            <img
                                src={ssbImage}
                                className="card-img-top mx-auto d-block app-image"
                                alt="Salon Slot Booking App"
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold">Salon Slot Booking App</h5>
                                <p className="card-text text-muted">
                                    For customers to browse salons, choose services, and book appointments easily.
                                </p>
                                <a
                                    href="https://salonmanagement.in/"
                                    className="btn btn-outline-primary"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Download Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How it Works */}
            <section className="how-it-works-section py-3">
                <div className="hero-section text-center">
                    <h2 className="fw-bold mb-4">How It Works</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-md-4">
                            <div className="card p-3 step-card shadow-sm h-100">
                                <h4>1️⃣ Find a Salon</h4>
                                <p>Get a unique link from your salon owner and explore their services.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="card p-3 step-card shadow-sm h-100">
                                <h4>2️⃣ Choose Date & Time</h4>
                                <p>Pick a convenient slot and your preferred staff member.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="card p-3 step-card shadow-sm h-100">
                                <h4>3️⃣ Confirm & Relax</h4>
                                <p>Book instantly and enjoy your salon visit without waiting.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="benefits-section py-3">
                <div className="hero-section text-center">
                    <h2 className="fw-bold mb-4">Why Choose Us?</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-6 col-md-3">
                            <div className="card benefit-card p-3 shadow-sm h-100">
                                <h5>✔ Hassle-Free</h5>
                                <p>Book appointments anytime, anywhere.</p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="card benefit-card p-3 shadow-sm h-100">
                                <h5>✔ Real-Time</h5>
                                <p>Check live slot & staff availability.</p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="card benefit-card p-3 shadow-sm h-100">
                                <h5>✔ Transparent</h5>
                                <p>See exact prices before booking.</p>
                            </div>
                        </div>
                        <div className="col-6 col-md-3 mb-2">
                            <div className="card benefit-card p-3 shadow-sm h-100">
                                <h5>✔ No Waiting</h5>
                                <p>Get served at your scheduled time.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
